import React, { PropTypes } from "react";

export default function HeaderView({ title, url, count, labels }) {
    return (<a className="btn btn-link negative" href={url}>{count} {count === 1 ? labels.single : labels.multiple} <i className="icon icon-basket  pull-right"></i></a>);
}

HeaderView.propTypes = {
    url: PropTypes.string,
    title: PropTypes.string,
    count: PropTypes.number,
    labels: PropTypes.shape({
        open: PropTypes.string,
        single: PropTypes.string,
        multiple: PropTypes.string,
    }),
};

HeaderView.defaultProps = {
    count: 0,
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Basket/Views/HeaderView.jsx